<template>
  <div class="bg-white mt-20">
    <GalleryLists />
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import GalleryLists from "./components/GalleryLists.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
export default {
  components: {
    GalleryLists,
    DownloadApp,
    Footer,
  },
};
</script>
